import React, { useCallback, useState } from 'react';
import axios from "axios";
import data from "../assets/apiRoutes.json";

export function getParameterByName(name, url) {
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`(?:[?&]|^)${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
export function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== '';
}
export function CustomTitle(data) {
    return <div className="header">{data.Title}</div>;
}